import sentry from '../sentry';

export const fetchPassTemplates = async (
  authAxios,
  filterEntity = null,
  searchTerm = null,
  passTemplateUuids = []
) => {
  try {
    const entityPath = filterEntity ? `entities/${filterEntity.uuid}/` : '';
    const endpoint =
      'passes/templates?fields=name,id,uuid,passDownloadTemplateId&include_localised=true';
    const queryParam = searchTerm ? `&search=${searchTerm}` : '';

    const url = `${entityPath}${endpoint}${queryParam}`;
    const response = await authAxios.get(url);

    const passTemplates = response.data.data || [];

    let passTemplatesList = [];
    let selectedTemplates = [];

    passTemplates.forEach((template) => {
      const option = {
        label: template.name,
        value: template.id,
      };

      if (!template.pass_download_template_id) {
        passTemplatesList.push(option);
      } else if (passTemplateUuids.includes(template.uuid)) {
        selectedTemplates.push(option);
        passTemplatesList.push(option);
      }
    });

    return { passTemplatesList, selectedTemplates };
  } catch (error) {
    sentry.sendError(error);
    console.log(error);
    return { passTemplatesList: [], selectedTemplates: [] };
  }
};
